import { db } from "./firebase";
import { doc, getDoc, setDoc, deleteDoc, collection, getDocs } from "firebase/firestore";

const storage = {
  async get(key, shared = false) {
    try {
      const docRef = doc(db, shared ? "shared" : "personal", key.replace(/\//g, "_"));
      const snap = await getDoc(docRef);
      if (!snap.exists()) return null;
      return { key, value: snap.data().value, shared };
    } catch (e) {
      console.error("storage.get error:", e);
      return null;
    }
  },

  async set(key, value, shared = false) {
    try {
      const docRef = doc(db, shared ? "shared" : "personal", key.replace(/\//g, "_"));
      await setDoc(docRef, { value, updatedAt: Date.now() });
      return { key, value, shared };
    } catch (e) {
      console.error("storage.set error:", e);
      return null;
    }
  },

  async delete(key, shared = false) {
    try {
      const docRef = doc(db, shared ? "shared" : "personal", key.replace(/\//g, "_"));
      await deleteDoc(docRef);
      return { key, deleted: true, shared };
    } catch (e) {
      console.error("storage.delete error:", e);
      return null;
    }
  },

  async list(prefix = "", shared = false) {
    try {
      const colRef = collection(db, shared ? "shared" : "personal");
      const snap = await getDocs(colRef);
      const keys = snap.docs
        .map(d => d.id.replace(/_/g, "/"))
        .filter(k => k.startsWith(prefix));
      return { keys, prefix, shared };
    } catch (e) {
      console.error("storage.list error:", e);
      return null;
    }
  }
};

export default storage;
